/*
  © 2024 ISB
*/

/*
  Delivery date scheduler
*/
function updateDeliveryDate(selectedDate) {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        'Select a delivery date': selectedDate
      }
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Delivery date updated successfully');
  })
  .catch(error => {
    console.error('Error updating delivery date:', error);
  });
}

/*
  Cart collapses - scroll to element
*/
window.ksCartDrawerFixScrollPosition = () => {
  setTimeout(() => {
    const wrapper = document.querySelector('.ks-cart-drawer-wrapper')
    wrapper.scroll({ top: wrapper.scrollHeight, behavior: 'smooth' })
  }, 250)
}

/*
  Cart goal
*/
class KsCartGoal extends HTMLElement {
  constructor () {
    super()
        
    this.progressBar = this.querySelector('.bs-progress-bar')
    this.animateProgressBar()
    this.initConfetti()
  }

  animateProgressBar () {
    setTimeout(() => {
      this.progressBar.style.width = this.progressBar.dataset.width
    }, 250)
  }

  async initConfetti () {
    if (this.dataset.showConfetti === 'false') return

    const goalCompleted = Number(this.dataset.goalCompleted)
    const prevGoalCompleted = Number(localStorage.getItem('ks-cart-goal-completed') || 0)

    if (prevGoalCompleted !== goalCompleted) {
      localStorage.setItem('ks-cart-goal-completed', goalCompleted)
    }

    if (goalCompleted <= prevGoalCompleted) return

    const myCanvas = document.createElement('canvas')
    myCanvas.setAttribute('id', 'ks-cart-goal-confetti-canvas')

    if (this.closest('.cart-drawer')) {
      this.closest('.cart-drawer').querySelector('.drawer__inner').insertAdjacentElement('afterbegin', myCanvas)
    }
    
    const myConfetti = window.confetti.create(myCanvas)

    myConfetti({
      particleCount: 400,
      spread: 90
    })

    setTimeout(() => {
      myCanvas.remove()
    }, 4000)
  }
}
customElements.define('ks-cart-goal', KsCartGoal)

/*
  Cart upsells
*/
class KsCartUpsells extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('select[name="id"]').forEach(select => {
      select.addEventListener('change', (event) => {
        event.preventDefault()
        const imgSrc = select.options[select.selectedIndex].dataset.variantImg

        if (imgSrc) {
          const img = select.closest('.ks-cart-upsell-item').querySelector('.ks-cart-upsell-item-image img')
          img.src = imgSrc
        }
      })
    })
  }
}
customElements.define('ks-cart-upsells', KsCartUpsells)

/*
  Shipping calculator - Market-specific version
*/
class KsCartShippingCalculator extends HTMLElement {
  constructor () {
    super()

    this.country = this.querySelector('#ks-shipping-calculator-country')
    this.province = this.querySelector('#ks-shipping-calculator-province')
    this.zip = this.querySelector('#ks-shipping-calculator-zip')
    this.alert = this.querySelector('#ks-shipping-calculator-alert')
    this.btn = this.querySelector('button')

    // Get market countries from data attribute
    this.marketCountries = this.dataset.marketCountries ? JSON.parse(this.dataset.marketCountries) : []
    
    this.initCommonJsScript()
    this.btn.addEventListener('click', this.onSubmit.bind(this))
  }

  async initCommonJsScript () {
    const script = document.createElement('script')
    script.src = this.dataset.shopifyCommonJs
    document.head.appendChild(script)

    await new Promise(resolve => setTimeout(resolve, 1000))

    // Filter countries to only show market countries
    this.filterMarketCountries()

    new window.Shopify.CountryProvinceSelector('ks-shipping-calculator-country', 'ks-shipping-calculator-province', {
      hideElement: 'ks-shipping-calculator-province-wrapper'
    })

    this.country.options[0].textContent = this.country.getAttribute('aria-label')

    // Always show province/state dropdown
    this.showProvinceDropdown()
    
    // Add event listener to country change
    this.country.addEventListener('change', this.onCountryChange.bind(this))

    this.insertCustomerData()
  }

  filterMarketCountries() {
    if (this.marketCountries.length === 0) return

    // Get all options except the first placeholder
    const allOptions = Array.from(this.country.options).slice(1)
    const addedCountries = new Set() // Track added countries to prevent duplicates
    
    // Remove options that are not in market countries and prevent duplicates
    allOptions.forEach(option => {
      const countryCode = option.value
      const countryName = option.textContent
      
      // Check if country is in market (by code or name)
      const isInMarket = this.marketCountries.some(marketCountry => 
        marketCountry.code === countryCode || 
        marketCountry.name === countryName ||
        marketCountry === countryCode ||
        marketCountry === countryName
      )
      
      // Remove if not in market OR if already added (duplicate)
      if (!isInMarket || addedCountries.has(countryCode)) {
        option.remove()
      } else {
        addedCountries.add(countryCode)
      }
    })
  }

  showProvinceDropdown() {
    const provinceWrapper = document.getElementById('ks-shipping-calculator-province-wrapper')
    if (provinceWrapper) {
      provinceWrapper.style.display = 'block'
    }
  }

  onCountryChange() {
    // Clear previous shipping rates when country changes
    this.clearAlert()
    
    // Clear zip code when country changes (optional)
    this.zip.value = ''
    
    // Reset province dropdown to default when country changes
    if (this.province.options.length > 0) {
      this.province.selectedIndex = 0
    }
  }

  insertCustomerData () {
    const country = this.dataset.customerCountry || ''
    const province = this.dataset.customerProvince || ''
    const zip = this.dataset.customerZip || ''

    if (country.length) {
      // Check if customer country is available in filtered list
      const countryOption = Array.from(this.country.options).find(option => 
        option.value === country || option.textContent === country
      )
      
      if (countryOption) {
        this.country.value = country
        this.country.dispatchEvent(new CustomEvent('change'))
        
        // Add delay to ensure province options are loaded
        setTimeout(() => {
          if (province.length) {
            const provinceOption = Array.from(this.province.options).find(option => 
              option.value === province || option.textContent === province
            )
            if (provinceOption) {
              this.province.value = province
            }
          }
        }, 700)
        
        if (zip.length) {
          this.zip.value = zip
        }
      }
    }
  }

  async onSubmit () {
    // Enhanced validation
    const countryValue = this.country.value?.trim() || ''
    const provinceValue = this.province.value?.trim() || ''
    const zipValue = this.zip.value?.trim() || ''

    if (!countryValue) {
      this.showError('Please select a country')
      return
    }

    // Enhanced validation for postal code
    if (!zipValue) {
      this.showError('Please enter a postal/zip code')
      return
    }

    // Basic postal code validation (can be enhanced based on country)
    if (zipValue.length < 3) {
      this.showError('Please enter a valid postal/zip code')
      return
    }

    this.btn.classList.add('loading')
    this.btn.querySelector('.loading__spinner').classList.remove('hidden')
    this.clearAlert()

    try {
      // Build shipping address object
      const shippingAddress = {
        'shipping_address[country]': countryValue,
        'shipping_address[zip]': zipValue
      }

      // Only add province if it's selected and not empty
      if (provinceValue && provinceValue !== '') {
        shippingAddress['shipping_address[province]'] = provinceValue
      }

      const params = new URLSearchParams(shippingAddress)

      console.log('Requesting shipping rates for:', shippingAddress)

      // First, prepare shipping rates
      const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?${params.toString()}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })

      console.log('Prepare response status:', prepareResponse.status)

      if (!prepareResponse.ok) {
        const errorText = await prepareResponse.text()
        console.error('Prepare response error:', errorText)
        
        try {
          const errorData = JSON.parse(errorText)
          this.displayError(errorData)
        } catch (e) {
          this.showError('Unable to calculate shipping rates for this address.')
        }
        return
      }

      // Wait for Shopify to calculate rates
      await new Promise(resolve => setTimeout(resolve, 1500))
      
      // Get the calculated shipping rates
      const asyncResponse = await fetch(`/cart/async_shipping_rates.json?${params.toString()}`, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })

      console.log('Async response status:', asyncResponse.status)

      if (asyncResponse.ok) {
        const data = await asyncResponse.json()
        console.log('Shipping rates data:', data)
        this.displayShippingRates(data)
      } else {
        // If no rates found with province, try without province for country-level rates
        if (provinceValue) {
          console.log('Retrying without province for country-level rates...')
          await this.retryWithoutProvince(countryValue, zipValue)
        } else {
          const errorText = await asyncResponse.text()
          console.error('Async response error:', errorText)
          
          try {
            const errorData = JSON.parse(errorText)
            this.displayError(errorData)
          } catch (e) {
            this.showError('No shipping rates available for this address.')
          }
        }
      }
    } catch (error) {
      console.error('Shipping calculation error:', error)
      this.showError('An error occurred while calculating shipping rates. Please try again.')
    } finally {
      this.btn.classList.remove('loading')
      this.btn.querySelector('.loading__spinner').classList.add('hidden')
    }
  }

  async retryWithoutProvince(countryValue, zipValue) {
    try {
      // Try again without province for country-level shipping rates
      const shippingAddress = {
        'shipping_address[country]': countryValue,
        'shipping_address[zip]': zipValue
      }

      const params = new URLSearchParams(shippingAddress)

      console.log('Retrying shipping rates without province:', shippingAddress)

      // Prepare shipping rates without province
      const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?${params.toString()}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      })

      if (prepareResponse.ok) {
        // Wait for calculation
        await new Promise(resolve => setTimeout(resolve, 1500))
        
        // Get rates
        const asyncResponse = await fetch(`/cart/async_shipping_rates.json?${params.toString()}`, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          }
        })

        if (asyncResponse.ok) {
          const data = await asyncResponse.json()
          console.log('Country-level shipping rates:', data)
          this.displayShippingRates(data)
        } else {
          this.showError('No shipping rates available for this address.')
        }
      } else {
        this.showError('Unable to calculate shipping rates for this address.')
      }
    } catch (error) {
      console.error('Retry without province error:', error)
      this.showError('No shipping rates available for this address.')
    }
  }

  displayShippingRates(data) {
    let list = ''

    if (data.shipping_rates && data.shipping_rates.length > 0) {
      data.shipping_rates.forEach(rate => {
        const name = rate.presentment_name || rate.name || 'Shipping'
        const price = this.formatPrice(rate.price || '0.00')
        const currency = rate.currency || ''
        
        list += `
          <li class="shipping-rate-item">
            <span class="rate-name">${this.escapeHtml(name)}</span>
            <span class="rate-price">${this.escapeHtml(currency)} ${this.escapeHtml(price)}</span>
          </li>
        `
      })

      this.alert.innerHTML = `
        <div class="shipping-rates-success">
          <h4>Available shipping options:</h4>
          <ul class="shipping-rates-list">
            ${list}
          </ul>
        </div>
      `
      this.alert.classList.remove('ks-alert-danger', 'ks-alert-warning')
      this.alert.classList.add('ks-alert-success')
      this.alert.removeAttribute('hidden')
    } else {
      this.alert.innerHTML = `
        <div class="shipping-rates-warning">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
          </svg>
          <span>${this.dataset.textNoResultsFound || 'No shipping rates found for this address. Please check your postal code and try again.'}</span>
        </div>
      `
      this.alert.classList.remove('ks-alert-danger', 'ks-alert-success')
      this.alert.classList.add('ks-alert-warning')
      this.alert.removeAttribute('hidden')
    }
  }

  displayError(errorData) {
    let errorMessage = ''

    if (errorData && typeof errorData === 'object') {
      // Handle different error structures
      if (errorData.message) {
        errorMessage = errorData.message
      } else if (errorData.error) {
        errorMessage = errorData.error
      } else if (errorData.errors) {
        if (Array.isArray(errorData.errors)) {
          errorMessage = errorData.errors.join(', ')
        } else if (typeof errorData.errors === 'object') {
          const errorList = []
          for (const [key, value] of Object.entries(errorData.errors)) {
            const keyFormatted = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
            const valueFormatted = Array.isArray(value) ? value.join(', ') : (value?.toString() || 'Invalid')
            errorList.push(`${keyFormatted}: ${valueFormatted}`)
          }
          errorMessage = errorList.join('; ')
        } else {
          errorMessage = errorData.errors.toString()
        }
      } else {
        // Generic object error
        const errorList = []
        for (const [key, value] of Object.entries(errorData)) {
          const keyFormatted = key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
          const valueFormatted = Array.isArray(value) ? value.join(', ') : (value?.toString() || 'Unknown error')
          errorList.push(`${keyFormatted}: ${valueFormatted}`)
        }
        errorMessage = errorList.join('; ')
      }
    } else {
      errorMessage = 'Unable to calculate shipping rates for this address.'
    }

    this.showError(errorMessage)
  }

  showError(message) {
    this.alert.innerHTML = `
      <div class="shipping-rates-error">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
        <span>${this.escapeHtml(message)}</span>
      </div>
    `
    this.alert.classList.remove('ks-alert-success', 'ks-alert-warning')
    this.alert.classList.add('ks-alert-danger')
    this.alert.removeAttribute('hidden')
  }

  clearAlert() {
    this.alert.setAttribute('hidden', '')
    this.alert.classList.remove('ks-alert-success', 'ks-alert-warning', 'ks-alert-danger')
  }

  formatPrice(price) {
    // Convert price to number and format
    const numPrice = parseFloat(price)
    return numPrice.toFixed(2)
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}

customElements.define('ks-cart-shipping-calculator', KsCartShippingCalculator)
 
/*
  Cart discount form
*/
class KsCartDiscountForm extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('input')
    this.btn = this.querySelector('button')
    this.btn.addEventListener('click', this.onSubmit.bind(this))
  }

  async onSubmit () {
    this.btn.classList.add('loading')
    this.btn.querySelector('.loading__spinner').classList.remove('hidden')

    await fetch(`${window.Shopify.routes.root_url}discount/${this.input.value}`)
    window.location.href = '/checkout'

    setTimeout(() => {
      this.btn.classList.remove('loading')
      this.btn.querySelector('.loading__spinner').classList.add('hidden')
    }, 2000)
  }
}
customElements.define('ks-cart-discount-form', KsCartDiscountForm)

/*
  Upgrade to subscription
*/
class KsCartSubUpgradeSelector extends HTMLElement {
  constructor () {
    super()

    this.select = this.querySelector('select')
    this.select.addEventListener('change', this.onChange.bind(this))
  }

  async onChange (event) {
    event.preventDefault()
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items')
    await cartItems.updateQuantity(this.dataset.index, 0)

    await new Promise(resolve => setTimeout(resolve, 500))

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
    let sections = cart.getSectionsToRender().map((section) => section.id)

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(this.dataset.variantId),
            quantity: Number(this.dataset.quantity),
            selling_plan: Number(this.select.value)
          }], 
          sections 
        })
    })
    const responseData = await response.json()
    cart.renderContents(responseData)

    if (cart && cart.classList.contains('is-empty')) 
      cart.classList.remove('is-empty')
  }
}
customElements.define('ks-cart-sub-upgrade-selector', KsCartSubUpgradeSelector)
